(function () {
  var rm = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  function revealAll() {
    document.querySelectorAll('[data-reveal]').forEach(function (el) { el.classList.add('is-in'); });
  }
  if (rm || !('IntersectionObserver' in window)) {
    revealAll();
  } else {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -36px 0px' });
    document.querySelectorAll('[data-reveal]').forEach(function (el) { io.observe(el); });
  }
  document.addEventListener('click', function (ev) {
    var g = ev.target.closest ? ev.target.closest('[data-gthumb]') : null;
    if (g) {
      var wrap = g.closest('[data-gallery]');
      if (wrap) {
        var coverEl = wrap.querySelector('[data-gview="cover"]');
        var spreadEl = wrap.querySelector('.wsb-spreadview');
        wrap.querySelectorAll('[data-gthumb]').forEach(function (b) { b.classList.remove('is-on'); });
        g.classList.add('is-on');
        if (g.hasAttribute('data-cover')) {
          if (coverEl) coverEl.hidden = false;
          if (spreadEl) spreadEl.hidden = true;
        } else {
          if (spreadEl) { spreadEl.src = g.getAttribute('data-full'); spreadEl.alt = g.getAttribute('data-alt') || ''; spreadEl.hidden = false; }
          if (coverEl) coverEl.hidden = true;
        }
      }
      return;
    }
    var t = ev.target.closest ? ev.target.closest('[data-step]') : null;
    if (t) {
      var input = t.parentNode.querySelector('input');
      if (input) {
        var min = parseInt(input.min || '0', 10);
        var v = parseInt(input.value || '1', 10) + parseInt(t.getAttribute('data-step'), 10);
        if (isNaN(v)) v = 1;
        input.value = Math.max(min, v);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
      return;
    }
    if (ev.target.closest && ev.target.closest('[data-menu-open]')) {
      var s = document.querySelector('[data-menu]');
      if (s) { s.hidden = false; document.body.classList.add('wsb-lock'); }
      return;
    }
    if (ev.target.closest && ev.target.closest('[data-menu-close]')) {
      var s2 = document.querySelector('[data-menu]');
      if (s2) { s2.hidden = true; document.body.classList.remove('wsb-lock'); }
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      var s = document.querySelector('[data-menu]');
      if (s && !s.hidden) { s.hidden = true; document.body.classList.remove('wsb-lock'); }
    }
  });
  document.addEventListener('change', function (ev) {
    var i = ev.target;
    if (i && i.name === 'updates[]') {
      var f = i.closest('form');
      if (f && f.id === 'wsb-cartform') f.submit();
    }
  });
})();
(function () {
  var pop = document.querySelector('[data-exit]');
  if (!pop) return;
  var KEY = 'wsb-welcome-v1', seen = false;
  try { seen = sessionStorage.getItem(KEY) === '1'; } catch (e) {}
  function mark() { try { sessionStorage.setItem(KEY, '1'); } catch (e) {} }
  function open() { pop.hidden = false; document.body.classList.add('wsb-lock'); }
  function hide() { pop.hidden = true; document.body.classList.remove('wsb-lock'); }
  var fw = pop.querySelector('[data-exit-form]');
  var dw = pop.querySelector('[data-exit-done]');
  if (/(^|[?&])customer_posted=true/.test(location.search)) {
    if (fw) fw.hidden = true;
    if (dw) dw.hidden = false;
    mark();
    open();
  } else if (!seen) {
    setTimeout(function () { mark(); open(); }, 1800);
  }
  pop.addEventListener('click', function (e) {
    if (e.target.closest('[data-exit-dismiss]')) { hide(); return; }
    var c = e.target.closest('[data-exit-copy]');
    if (c) {
      var code = c.getAttribute('data-code') || '';
      var done = function () { c.textContent = 'Copied'; };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(done, done);
      } else {
        var ta = document.createElement('textarea');
        ta.value = code;
        document.body.appendChild(ta);
        ta.select();
        try { document.execCommand('copy'); } catch (err) {}
        document.body.removeChild(ta);
        done();
      }
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !pop.hidden) hide();
  });
})();

/* ===== v3.0 additions ===== */
(function () {
  var bar = document.querySelector('[data-stickybar]');
  if (!bar) return;
  var target = document.querySelector('.wsb-btn--buynow');
  if (!target || !('IntersectionObserver' in window)) return;
  var io = new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      var past = !e.isIntersecting && e.boundingClientRect.top < 0;
      bar.hidden = !past;
      bar.classList.toggle('is-show', past);
      document.body.classList.toggle('wsb-hasbar', past);
    });
  }, { threshold: 0 });
  io.observe(target);
})();
(function () {
  function embed(url, poster) {
    var m = url.match(/(?:youtube\.com\/(?:watch\?v=|shorts\/|embed\/)|youtu\.be\/)([\w-]{6,})/);
    if (m) return '<iframe src="https://www.youtube-nocookie.com/embed/' + m[1] + '?autoplay=1&playsinline=1&rel=0&controls=0&fs=0&iv_load_policy=3&cc_load_policy=0&hl=en" allow="autoplay; encrypted-media; picture-in-picture; web-share" allowfullscreen title="A look inside"></iframe>';
    m = url.match(/vimeo\.com\/(\d+)/);
    if (m) return '<iframe src="https://player.vimeo.com/video/' + m[1] + '?autoplay=1" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen title="A look inside"></iframe>';
    return '<video controls autoplay playsinline src="' + url + '"' + (poster ? ' poster="' + poster + '"' : '') + '></video>';
  }
  document.addEventListener('click', function (ev) {
    if (!ev.target.closest) return;
    var vv = document.querySelector('[data-videoview]');
    if (!vv) return;
    var vbtn = ev.target.closest('[data-gvideo]');
    if (vbtn) {
      var wrap = vbtn.closest('[data-gallery]');
      if (!wrap) return;
      wrap.querySelectorAll('[data-gthumb],[data-gvideo]').forEach(function (b) { b.classList.remove('is-on'); });
      vbtn.classList.add('is-on');
      var cover = wrap.querySelector('[data-gview="cover"]');
      var sp = wrap.querySelector('.wsb-spreadview');
      if (cover) cover.hidden = true;
      if (sp) sp.hidden = true;
      vv.innerHTML = embed(vbtn.getAttribute('data-video') || '', vbtn.getAttribute('data-poster') || '');
      vv.hidden = false;
      return;
    }
    if (ev.target.closest('[data-gthumb]') && !vv.hidden) {
      vv.hidden = true;
      vv.innerHTML = '';
      document.querySelectorAll('[data-gvideo]').forEach(function (b) { b.classList.remove('is-on'); });
    }
  });
})();
(function () {
  var f = document.querySelector('[data-finder]');
  if (!f) return;
  var a = {}, cur = 1;
  function show(n) {
    cur = n;
    f.querySelectorAll('[data-fstep]').forEach(function (p) { p.hidden = +p.getAttribute('data-fstep') !== n; });
    var r = f.querySelector('[data-fresult]'); if (r) r.hidden = true;
    var b = f.querySelector('[data-fback]'); if (b) b.hidden = n < 2;
    var d = f.querySelector('[data-fdots]'); if (d) d.textContent = 'Step ' + n + ' of 3';
  }
  function result() {
    var who = a.s1, st = a.s3, key, why;
    if (who === 'gift') { key = 'gifts'; why = 'For gifting, most families choose a set — this edit gathers the ones that travel best.'; }
    else if (who === 'both') {
      if (st === 'mid') { key = 'trset'; why = 'Mid-journey, the 24-month tracker keeps the everyday rhythm — with both guides beside it.'; }
      else { key = 'set'; why = 'For starting the conversation together, most families choose the Parent + Daughter Set.'; }
    } else if (who === 'daughter') {
      key = 'daughter';
      why = st === 'early' ? 'Preparing early is a gift — this guide meets her gently, before the questions arrive.' : 'Written just for her — calm, clear, and shame-free.';
    } else {
      key = 'parent';
      why = st === 'early' ? 'This companion gives you the words before you need them.' : 'Calm words and practical steps for your side of the conversation.';
    }
    cur = 4;
    var url = f.getAttribute('data-url-' + key) || '/collections/all';
    var label = f.getAttribute('data-label-' + key) || 'View';
    f.querySelectorAll('[data-fstep]').forEach(function (p) { p.hidden = true; });
    var r = f.querySelector('[data-fresult]');
    r.querySelector('[data-fwhy]').textContent = why;
    var go = r.querySelector('[data-fgo]');
    go.href = url;
    go.textContent = label;
    r.hidden = false;
    var b = f.querySelector('[data-fback]'); if (b) b.hidden = false;
    var d = f.querySelector('[data-fdots]'); if (d) d.textContent = 'Your match';
  }
  var sw = f.querySelector('[data-fstart-wrap]');
  if (f.getAttribute('data-start-open') === 'true' || !sw) {
    if (sw) sw.hidden = true;
    show(1);
  } else {
    f.classList.add('is-collapsed');
  }
  f.addEventListener('click', function (e) {
    if (e.target.closest('[data-fstart]')) {
      f.classList.remove('is-collapsed');
      if (sw) sw.hidden = true;
      show(1);
      return;
    }
    var o = e.target.closest('[data-fval]');
    if (o) {
      var panel = o.closest('[data-fstep]');
      var step = +panel.getAttribute('data-fstep');
      a['s' + step] = o.getAttribute('data-fval');
      panel.querySelectorAll('.wsb-format').forEach(function (x) { x.classList.remove('is-on'); });
      o.classList.add('is-on');
      if (step === 3) result(); else show(step + 1);
      return;
    }
    if (e.target.closest('[data-fback]')) { show(Math.max(1, Math.min(cur, 4) - 1)); return; }
    if (e.target.closest('[data-frestart]')) {
      a = {};
      f.querySelectorAll('.wsb-format').forEach(function (x) { x.classList.remove('is-on'); });
      show(1);
    }
  });
})();
(function () {
  function syncCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = count > 0 ? ' · ' + count : ''; });
  }
  function syncBar(total, count) {
    var bar = document.querySelector('[data-announce]');
    if (!bar) return;
    var t = +bar.getAttribute('data-threshold') || 0;
    if (!t) return;
    if (count > 0 && total === 0) { bar.hidden = true; return; }
    bar.hidden = false;
    var el = bar.querySelector('[data-announce-text]');
    var sym = bar.getAttribute('data-symbol') || '£';
    var ok = total >= t;
    var money = function (n) { return sym + (n / 100).toFixed(2).replace(/\.00$/, ''); };
    var mu = bar.getAttribute('data-msg-unlocked') || "You've unlocked free shipping";
    var mo = bar.getAttribute('data-msg-over') || 'Free shipping on orders over {threshold}';
    var mp = bar.getAttribute('data-msg-progress') || 'Add {amount} more to unlock free shipping';
    var msg = ok ? mu : (count === 0 ? mo.replace('{threshold}', money(t)) : mp.replace('{amount}', money(t - total)));
    if (el) el.textContent = msg;
    bar.classList.toggle('is-unlocked', ok);
  }
  var drawer = document.querySelector('[data-drawer]');
  if (!drawer) return;
  function post(u, b) {
    return fetch(u, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(b) }).then(function (r) { return r.json(); });
  }
  function refresh() {
    return fetch('/?sections=wsb-cart-drawer').then(function (r) { return r.json(); }).then(function (j) {
      var html = j['wsb-cart-drawer'];
      if (!html) return;
      var d = document.createElement('div');
      d.innerHTML = html;
      var na = d.querySelector('[data-drawer]');
      var nb = d.querySelector('[data-drawer-body]');
      var ob = drawer.querySelector('[data-drawer-body]');
      if (nb && ob) ob.innerHTML = nb.innerHTML;
      var nc = d.querySelector('[data-drawer-count]');
      var oc = drawer.querySelector('[data-drawer-count]');
      if (nc && oc) oc.textContent = nc.textContent;
      if (na) {
        var count = +na.getAttribute('data-dcount') || 0;
        var total = +na.getAttribute('data-dtotal') || 0;
        var phys = na.hasAttribute('data-dphys') ? (+na.getAttribute('data-dphys') || 0) : total;
        drawer.setAttribute('data-dcount', count);
        drawer.setAttribute('data-dtotal', total);
        syncCount(count);
        syncBar(phys, count);
      }
    }).catch(function () {});
  }
  function open() { refresh().then(function () { drawer.hidden = false; document.body.classList.add('wsb-lock'); }); }
  function close() { drawer.hidden = true; document.body.classList.remove('wsb-lock'); }
  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var l = e.target.closest('[data-cart-link]');
    if (l) { e.preventDefault(); open(); return; }
    if (e.target.closest('[data-drawer-close]')) { close(); return; }
    var st = e.target.closest('[data-dstep]');
    if (st) {
      var input = st.parentNode.querySelector('input');
      var q = Math.max(0, parseInt((input && input.value) || '1', 10) + parseInt(st.getAttribute('data-dstep'), 10));
      post('/cart/change.js', { line: +st.getAttribute('data-line'), quantity: q }).then(refresh);
      return;
    }
    var rm = e.target.closest('[data-dremove]');
    if (rm) { e.preventDefault(); post('/cart/change.js', { line: +rm.getAttribute('data-line'), quantity: 0 }).then(refresh); return; }
    var ad = e.target.closest('[data-dadd]');
    if (ad) { ad.disabled = true; post('/cart/add.js', { id: +ad.getAttribute('data-dadd'), quantity: 1 }).then(refresh); return; }
  });
  drawer.addEventListener('change', function (e) {
    if (e.target.matches('[data-dnote]')) post('/cart/update.js', { note: e.target.value });
  });
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f.getAttribute || ((f.getAttribute('action') || '').indexOf('/cart/add') === -1)) return;
    if (f.closest('[data-stickybar]')) return;
    var sub = e.submitter;
    if (!sub || sub.name === 'return_to') return;
    e.preventDefault();
    var fd = new FormData(f);
    fd.delete('return_to');
    fetch('/cart/add.js', { method: 'POST', body: fd }).then(function (r) { return r.json(); }).then(open);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !drawer.hidden) close();
  });
})();
(function () {
  function check() {
    var w = document.querySelector('.jdgm-rev-widg');
    if (w && +(w.getAttribute('data-number-of-reviews') || '0') < 3) document.body.classList.add('wsb-jdgm-few');
  }
  setTimeout(check, 1500);
  setTimeout(check, 4000);
})();

/* ===== v3.5: purchase notices — newest first on first pass, then shuffled; rows from wsb.purchase_pops metafield ===== */
(function () {
  var el = document.querySelector('[data-wsb-pop]');
  if (!el) return;
  var rows = [];
  try { rows = JSON.parse(el.querySelector('[data-pop-rows]').textContent); } catch (e) {}
  rows = (rows || []).filter(function (r) { return r && r.name && r.city && r.product; });
  if (!rows.length) return;
  var iv = Math.max(3, +el.getAttribute('data-interval') || 8) * 1000;
  var SHOW = 5200, FADE = 450;
  var img = el.querySelector('[data-pop-img]');
  var icon = el.querySelector('[data-pop-icon]');
  var line = el.querySelector('[data-pop-line]');
  var order = [], hideT, nextT, dead = false, firstPass = true;
  function shuffle() {
    order = rows.map(function (_, i) { return i; });
    for (var i = order.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1)), t = order[i];
      order[i] = order[j];
      order[j] = t;
    }
  }
  function refill() {
    if (firstPass) {
      order = rows.map(function (_, i) { return i; }).reverse();
      firstPass = false;
    } else {
      shuffle();
    }
  }
  function coverFor(p) {
    var t = (p || '').toLowerCase();
    var both = t.indexOf('parent') !== -1 && t.indexOf('daughter') !== -1;
    if (both || t.indexOf('set') !== -1 || t.indexOf('bundle') !== -1) return el.getAttribute('data-img-pair');
    if (t.indexOf('tracker') !== -1) return el.getAttribute('data-img-tracker');
    if (t.indexOf('parent') !== -1) return el.getAttribute('data-img-parent');
    if (t.indexOf('daughter') !== -1) return el.getAttribute('data-img-daughter');
    return '';
  }
  function showOne() {
    if (dead) return;
    if (document.body.classList.contains('wsb-lock')) { nextT = setTimeout(showOne, iv); return; }
    if (!order.length) refill();
    var r = rows[order.pop()];
    var src = coverFor(r.product);
    if (src) { img.src = src; img.hidden = false; icon.style.display = 'none'; }
    else { img.hidden = true; icon.style.display = ''; }
    line.textContent = r.name + ' from ' + r.city + ' chose ' + r.product;
    el.hidden = false;
    requestAnimationFrame(function () { requestAnimationFrame(function () { el.classList.add('is-show'); }); });
    hideT = setTimeout(function () {
      el.classList.remove('is-show');
      setTimeout(function () { el.hidden = true; }, FADE);
    }, SHOW);
    nextT = setTimeout(showOne, SHOW + FADE + iv);
  }
  el.addEventListener('click', function (e) {
    if (e.target.closest('[data-pop-x]')) {
      dead = true;
      clearTimeout(hideT);
      clearTimeout(nextT);
      el.classList.remove('is-show');
      setTimeout(function () { el.hidden = true; }, FADE);
    }
  });
  refill();
  nextT = setTimeout(showOne, 6000);
})();
